import { ISystemStatusMessageInput } from '../model/ISystemStatusMessage'

// Banner feed (active messages), polled from the app shell.
export const LOAD_BANNER_STATUS_MESSAGES = 'SYSTEM_STATUS/LOAD_BANNER'
export type LoadBannerStatusMessagesAction = {
  type: typeof LOAD_BANNER_STATUS_MESSAGES
}
export const loadBannerStatusMessages = (): LoadBannerStatusMessagesAction => ({
  type: LOAD_BANNER_STATUS_MESSAGES
})

// Full list for the BackOffice management screen.
export const LOAD_STATUS_MESSAGES = 'SYSTEM_STATUS/LOAD_ADMIN'
export type LoadStatusMessagesAction = {
  type: typeof LOAD_STATUS_MESSAGES
}
export const loadStatusMessages = (): LoadStatusMessagesAction => ({
  type: LOAD_STATUS_MESSAGES
})

export const CREATE_STATUS_MESSAGE = 'SYSTEM_STATUS/CREATE'
export type CreateStatusMessageAction = {
  type: typeof CREATE_STATUS_MESSAGE
  input: ISystemStatusMessageInput
}
export const createStatusMessage = (
  input: ISystemStatusMessageInput
): CreateStatusMessageAction => ({
  type: CREATE_STATUS_MESSAGE,
  input
})

export const UPDATE_STATUS_MESSAGE = 'SYSTEM_STATUS/UPDATE'
export type UpdateStatusMessageAction = {
  type: typeof UPDATE_STATUS_MESSAGE
  id: number
  input: ISystemStatusMessageInput
}
export const updateStatusMessage = (
  id: number,
  input: ISystemStatusMessageInput
): UpdateStatusMessageAction => ({
  type: UPDATE_STATUS_MESSAGE,
  id,
  input
})

export const DELETE_STATUS_MESSAGE = 'SYSTEM_STATUS/DELETE'
export type DeleteStatusMessageAction = {
  type: typeof DELETE_STATUS_MESSAGE
  id: number
}
export const deleteStatusMessage = (id: number): DeleteStatusMessageAction => ({
  type: DELETE_STATUS_MESSAGE,
  id
})
